import { useParams } from "react-router-dom";

import userViewGuard from "~/hooks/useViewPermssionsCheck";
import { useClient } from "~/modules/client/api/client/clientQueries.ts";
import { useCompany } from "~/modules/client/api/company/companyQueries.ts";
import { useQuota } from "~/modules/client/api/quota/quotaQueries.ts";
import type { QuotaWithRelations } from "~/modules/client/api/quota/quotaTypes.ts";
import QuotaDetailsView from "~/modules/client/components/quota/QuotaDetailsView/QuotaDetailsView.tsx";
import LoadingPage from "~/pages/LoadingPage.tsx";
import { PermissionNames } from "~/types/entityNames.ts";

const QuotaDetailsPage = () => {
	const guard = userViewGuard(PermissionNames.CanManageProjects);
	if (guard) return guard;
	const { quotaId, clientId } = useParams();

	if (!quotaId || !clientId) return null;
	const {
		data: quotaData,
		isLoading: quotaIsLoading,
	} = useQuota(clientId, quotaId, true);

	const {
		data: clientData,
		isLoading: clientIsLoading,
	} = useClient(clientId);

	const {
		data: companyData,
		isLoading: companyIsLoading,
	} = useCompany(clientData?.companyId || "");

	if (quotaIsLoading || clientIsLoading || companyIsLoading) return <LoadingPage />;
	if (!quotaData || !clientData || !companyData) return null;

	return <QuotaDetailsView quotaData={quotaData as QuotaWithRelations}
							 clientData={clientData}
							 companyData={companyData}
	/>;
};

export default QuotaDetailsPage;